import cx from "classnames"
import { Fragment } from "react"
import { savedActionIcon } from "../../actions/actionIcons"
import { ACTION_COLOR_STYLES } from "../../actions/actionStyles"
import type { TaskActionRun } from "../../persistence/records"

export function ActionRunAnnotation({ run }: { run: TaskActionRun }) {
    const names = run.actions.map((action) => action.name)

    return (
        <div className="mb-2 min-w-0" aria-label={`Actions used: ${names.join(", ")}`} data-action-run={run.clientRequestId}>
            <div className="flex min-w-0 flex-wrap items-center gap-1">
                {run.actions.map((action, index) => {
                    const Icon = savedActionIcon(action.icon)
                    return (
                        <Fragment key={`${action.id}:${index}`}>
                            {index > 0 && (
                                <span className="text-[10px] text-muted" aria-hidden="true">
                                    →
                                </span>
                            )}
                            <span
                                className={cx(
                                    "inline-flex h-5 min-w-0 items-center gap-1 px-1.5 text-[10px] font-semibold",
                                    ACTION_COLOR_STYLES[action.color].swatch
                                )}
                            >
                                <Icon size={11} />
                                <span className="truncate">{action.name}</span>
                            </span>
                        </Fragment>
                    )
                })}
            </div>
        </div>
    )
}
